import styled from 'styled-components'
import {Dialog as DSDialog} from '~/src/design-system'
import {Button} from '~/src/design-system/Primitives'

export const StyledButton = styled(Button)`
  width: 120px;
  font-weight: normal;

  @media (max-width: 768px) {
    width: 300px;
  }
`

export const HeaderContainer = styled('div')`
  background-color: #fafafa;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  max-height: 50px;
  padding-left: 60px;
  padding-right: 60px;

  @media (max-width: 768px) {
    padding-left: var(--space-5);
    padding-right: var(--space-5);
  }
`

export const HeaderText = styled('div')`
  font-size: 18px;
  font-weight: 400;
`

export const Body = styled('div')`
  margin: 5px;
  background-color: var(--white);
  border-radius: var(--radius-sm);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 10px;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  @media (max-width: 768px) {
    padding-top: 100px;
    padding-bottom: 100px;
    padding-right: 55px;
    padding-left: 55px;
  }
`

export const ButtonBox = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 768px) {
    padding-bottom: 30px;
    width: 100%;
  }
`

export const BodyBox = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-wrap: nowrap;
  overflow-y: scroll;

  @media (max-width: 768px) {
    align-items: center;
  }
`

export const EnterCurrentPasswordText = styled('span')`
  color: #1f1f1f;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: var(--space-2);
`

export const PleaseEnterText = styled('span')`
  color: var(--neutral-600);
  font-size: 14px;
  font-weight: 400;
  margin-bottom: var(--space-8);
`

export const CurrentPasswordLabel = styled('span')`
  color: #707070;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: var(--space-2);
`

export const ChangePasswordDialogStyles = styled(DSDialog)<{verifyPasswordStep: number}>`
  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
  }

  /* Track */
  ::-webkit-scrollbar-track {
    display: none;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    display: none;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    display: none;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
  }

  & .MuiDialog-paper {
    width: 546px;
    height: ${(props) => (props.verifyPasswordStep === 1 ? '472px' : '603px')};
    overflow: hidden;
  }

  @media (max-width: 768px) {
    & .MuiDialog-paper {
      width: 100% !important;
      min-width: 100% !important;
      overflow-y: scroll;
      height: fit-content;
    }
    width: 100% !important;
    min-width: 100% !important;
    height: 100% !important;
    padding-left: var(--space-5);
    padding-right: var(--space-5);
  }
`

export const VerifyPasswordTextfieldContainer = styled('div')`
  width: 280px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`

export const ResetChangePasswordButtonDiv = styled('div')`
  margin-top: 10;
  width: 100%;

  @media (max-width: 768px) {
    padding-bottom: 30px;
  }
`
